import { render, staticRenderFns } from "./ModalDelayDays.vue?vue&type=template&id=6f8e0802&scoped=true"
import script from "./ModalDelayDays.vue?vue&type=script&lang=js"
export * from "./ModalDelayDays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8e0802",
  null
  
)

export default component.exports